import axios from "axios";
import { API_ENDPOINTS } from "./api-endpoints";
import toast from 'react-hot-toast';
import { MESSAGE } from "./mesage";
import AuthService from "../services/auth-service";

const APIService = {
    login: async (idToken) => {
        const payload = { idToken, provider: "MICROSOFT" };
        const headers = { "Content-Type": "application/json", source: "FINANCE" };

        return await APIService.callAPI({
            url: API_ENDPOINTS.USERS.LOGIN,
            method: "POST",
            payload,
            headers,
        });
    },

    authData: async () => {
        const headers = { "Content-Type": "application/json", source: "FINANCE", authorization: `Bearer ${AuthService.getToken()}` };
        return await APIService.callAPI({
            url: API_ENDPOINTS.USERS.AUTH_DATA,
            method: "GET",
            headers,
        });
    },

    callAPI: async ({ url, method = "GET", payload = null, headers = {} }) => {
        try {
            const response = await axios({
                url,
                method,
                data: payload,
                headers: {
                    "Content-Type": "application/json",
                    ...headers,
                },
            });
            return response.data;
        } catch (error) {
            if (error.status == 401) {
                toast.error(MESSAGE.ERROR.SESSION_EXPIRED);
            }
            throw error.response ? error.response.data : error;
        }
    },
};

export default APIService;
